import { Button } from "@/components/ui/button";
import { ChevronRight, ChevronLeft, SkipForward } from "lucide-react";

const StepNavigation = ({
  step,
  totalSteps,
  isOptionalStep,
  canProceed,
  isLoading,
  onBack,
  onNext,
  onSkip,
}) => (
  <div className="flex gap-3 pt-4">
    {step > 1 && (
      <Button variant="outline" onClick={onBack} className="flex-1 h-12" data-testid="back-btn">
        <ChevronLeft className="mr-2 h-4 w-4" />
        Back
      </Button>
    )}
    {isOptionalStep && (
      <Button variant="ghost" onClick={onSkip} className="h-12" data-testid="skip-btn">
        <SkipForward className="mr-2 h-4 w-4" />
        Skip
      </Button>
    )}
    <Button
      onClick={onNext}
      disabled={!canProceed || isLoading}
      className="flex-1 h-12 bg-primary hover:bg-primary/90"
      data-testid="next-btn"
    >
      {isLoading ? (
        <div className="w-5 h-5 border-2 border-primary-foreground border-t-transparent rounded-full animate-spin" />
      ) : step === totalSteps ? (
        "See My Results"
      ) : (
        <>
          Continue
          <ChevronRight className="ml-2 h-4 w-4" />
        </>
      )}
    </Button>
  </div>
);

export default StepNavigation;